import { Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { youtubeUrlRE } from 'src/core/helpers'
import React, { useState, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { formContentSelector, setProjectFormItemValue } from 'src/features'
import { ProjectDetailsVideo, CustomUrlInput, FormLabels, CustomCol } from 'src/components'

const ProjectFormVideo: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [videoAux, setVideoAux] = useState(null)
  const { video } = useAppSelector(formContentSelector)
  const isVideoVisible = videoAux && youtubeUrlRE.test(videoAux)

  useEffect(() => { setVideoAux(video) }, [video])

  const handleChange = (url: string) => {
    const value = youtubeUrlRE.test(url) ? url : null
    dispatch(setProjectFormItemValue({ key: 'video', value }))
  }

  return <div className='mb-5'>
    <Row>
      <CustomCol>
        <FormLabels
          title={t('Projects.Video')}
          subtitle={t('Projects.Form.VideoLabel')}
        />
      </CustomCol>

      <CustomCol>
        <CustomUrlInput
          name='video'
          isYoutubeUrl
          onChange={handleChange}
          placeholder={t('Projects.Form.VideoPlaceholder')}
        />
      </CustomCol>
    </Row>

    {isVideoVisible && <ProjectDetailsVideo video={videoAux} showCollapse={false} />}
  </div>
}

export default ProjectFormVideo
